import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { API, endpoint } from './api-endpoints';

export type Appearance = {
  id: string;
  org_id: string;
  primary_color: string;
  secondary_color: string;
  logo_path: string | null;
  favicon_path: string | null;
  logo_url: string | null;
  favicon_url: string | null;
  updated_at: string;
};

type ApiResponse<T> = {
  success: boolean;
  message: string;
  data: T;
};

@Injectable({ providedIn: 'root' })
export class AppearanceApi {
  constructor(private readonly http: HttpClient) {}

  get() {
    return firstValueFrom(this.http.get<ApiResponse<Appearance>>(endpoint(API.appearance.root)));
  }

  update(form: FormData) {
    return firstValueFrom(this.http.patch<ApiResponse<Appearance>>(endpoint(API.appearance.root), form));
  }

  reset() {
    return firstValueFrom(this.http.post<ApiResponse<Appearance>>(endpoint(API.appearance.reset), {}));
  }
}
